import React from 'react';

export const CriticalityBadge = ({ level }: { level: string }) => {
  switch (level) {
    case 'Critical':
      return <span className="px-2 py-0.5 rounded-full bg-earth-danger/20 text-earth-danger text-xs font-medium">Critical</span>;
    case 'High':
      return <span className="px-2 py-0.5 rounded-full bg-orange-500/20 text-orange-500 text-xs font-medium">High</span>;
    case 'Medium':
      return <span className="px-2 py-0.5 rounded-full bg-amber-500/20 text-amber-500 text-xs font-medium">Medium</span>;
    case 'Low':
      return <span className="px-2 py-0.5 rounded-full bg-[#40e0d0]/20 text-[#40e0d0] text-xs font-medium">Low</span>;
    default:
      return null;
  }
};

export const SpeciesStatusBadge = ({ status }: { status: string }) => {
  switch (status) {
    case 'Critically Endangered':
      return <span className="px-2 py-0.5 rounded-full bg-earth-danger/20 text-earth-danger text-xs font-medium whitespace-nowrap">Critically Endangered</span>;
    case 'Endangered':
      return <span className="px-2 py-0.5 rounded-full bg-orange-500/20 text-orange-500 text-xs font-medium">Endangered</span>;
    case 'Vulnerable':
      return <span className="px-2 py-0.5 rounded-full bg-amber-500/20 text-amber-500 text-xs font-medium">Vulnerable</span>;
    default:
      return null;
  }
};

export const TrendIndicator = ({ trend }: { trend: string }) => {
  switch (trend) {
    case 'Decreasing':
      return <span className="text-earth-danger text-xs">↓ Decreasing</span>;
    case 'Increasing':
      return <span className="text-[#40e0d0] text-xs">↑ Increasing</span>;
    case 'Stable':
      return <span className="text-blue-500 text-xs">→ Stable</span>;
    default:
      return null;
  }
};

export const getStatusColorClass = (rate: number, type?: string) => {
  if (rate >= 2.0) return 'text-earth-danger font-semibold';
  if (rate >= 1.0) return 'text-orange-500 font-semibold';
  if (rate >= 0.5) return 'text-amber-500 font-semibold';
  return 'text-[#40e0d0] font-semibold';
};
